import React from 'react'
import { Control, Controller, UseFormSetValue } from 'react-hook-form'
import { observer } from 'mobx-react-lite'
import Btn from './Btn'
import FilePreview from "./FilePreview";
import ImageUpload, { UploadedFile } from "./ImageUpload";


interface IDocumentProps {
  value?: string,
  template?: {
    name?: string,
    size?: number,
    type?: string,
    href?: string,
  }
}

interface IProps {
  control: Control<any>,
  setValue: UseFormSetValue<any>,
  item: IDocumentProps,
  isActive?: boolean
  disabled?: boolean
  uploadedFile?: UploadedFile | null
  onRemoveUploaded?: () => void
}

const DocumentTemplateCard = observer((props: IProps) => {
  const template = props.item.template
  const fieldName = `${props.item.value}ResourcesFile`

  return (
    <div className="document-template-card">
      {!!template?.href && (
        <FilePreview
          name={template?.name}
          type={template?.type}
          size={template?.size}
          hideRemove
        >
          <div className={'mt-md-8 mt-sm-6'}>
            <Btn disabled={props.disabled} href={template?.href} target={'_blank'}>Скачать шаблон</Btn>
          </div>
        </FilePreview>
      )}

      <div className={template?.href ? 'mt-md-4' : undefined}>
        <Controller
          control={props.control}
          name={fieldName}
          rules={{
            validate: (v) => {
              if (!props.isActive) return true
              if (props.uploadedFile?.href) return true
              return !!v || 'Укажите файл'
            }
          }}
          render={({ field: { value, onChange }, fieldState }) => (
            <div className={fieldState.error ? '_has-error' : ''}>
              <ImageUpload
                disabled={props.disabled}
                file={value}
                onChangeFile={onChange}
                uploadedFile={props.uploadedFile ?? null} 
                onRemoveUploaded={props.onRemoveUploaded} 
                text={'Формат: .pdf, .jpg, .png, .doc,  и .docx, вес до 2 MB.'}
                errorText={fieldState.error?.message}
              />
            </div>
          )}
        />
      </div>
    </div>
  )
})

export default DocumentTemplateCard
